import { Box, Td, Tr, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import type { AddressMudRecord } from 'types/api/address';

import { useI18n } from 'lib/i18n/context';

import { ADDRESS_MUD_KEYS } from '../i18n';
import { getValueString } from './utils';

type Props = {
  data?: AddressMudRecord;
};

const AddressMudRecordValues = ({ data }: Props) => {
  const { t } = useI18n();
  const valuesBgColor = useColorModeValue('blackAlpha.50', 'whiteAlpha.50');

  if (!data?.schema.value_names.length) {
    return null;
  }

  return (
    <>
      <Tr backgroundColor={ valuesBgColor } borderBottomStyle="hidden" >
        <Td fontWeight={ 600 } w="100px" fontSize="sm">{ t(ADDRESS_MUD_KEYS.fields.field) }</Td>
        <Td fontWeight={ 600 } w="90px" fontSize="sm">{ t(ADDRESS_MUD_KEYS.fields.type) }</Td>
        <Td fontWeight={ 600 } fontSize="sm">{ t(ADDRESS_MUD_KEYS.fields.value) }</Td>
      </Tr>
      {
        data?.schema.value_names.map((valName, index) => (
          <Tr key={ valName } backgroundColor={ valuesBgColor } borderBottomStyle="hidden">
            <Td fontWeight={ 400 } w="100px" py={ 0 } pb={ 4 } pr={ 0 }wordBreak="break-all">{ valName }</Td>
            <Td fontWeight={ 400 } w="90px" py={ 0 } pb={ 4 } wordBreak="break-all">{ data.schema.value_types[index] }</Td>
            <Td fontWeight={ 400 } wordBreak="break-word" py={ 0 } pb={ 4 }>
              <Box>
                { getValueString(data.record.decoded[valName]) }
              </Box>
            </Td>
          </Tr>
        ))
      }
    </>
  );
};

export default AddressMudRecordValues;
